/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { TextField, Divider, Grid, Paper, Snackbar } from "@material-ui/core";
import "./raw_files/styles.css";
import DatePicker from "react-modern-calendar-datepicker";
import { injectIntl } from "react-intl";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as account from "../_redux/accountRedux";
import {
  getProfileInfo,
  updatePassword,
  updateProfileInfo,
} from "../_redux/accountCrud";
import * as moment from "moment-jalaali";
import Alert from "@material-ui/lab/Alert";
import { Input } from "../../../../_metronic/_partials/controls";

export function UserInformationCard(props) {
  var phoneRegExp = new RegExp("^(\\+98|0)?9\\d{9}$");
  var emailRegExp = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );

  let { state } = useSelector(
    (state) => ({
      state: state.account,
    }),
    shallowEqual
  );
  const { user } = useSelector((state) => state.auth);

  const CustomerEditSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(3, "کارکترهای وارد شده کمتر از حد مجاز است")
      .max(50, "کارکترهای وارد شده بیشتر از حد مجاز است"),
    lastName: Yup.string()
      .min(3, "کارکترهای وارد شده کمتر از حد مجاز است")
      .max(50, "کارکترهای وارد شده بیشتر از حد مجاز است"),
    nationalCode: Yup.string()
      .min(10, "کارکترهای وارد شده کمتر از حد مجاز است")
      .max(10, "کارکترهای وارد شده بیشتر از حد مجاز است"),
    email: Yup.string().matches(emailRegExp, "ایمیل وارد شده صحیح نیست"),
    phone: Yup.string().matches(phoneRegExp, "فرمت وارد شده نادرست است"),
    address: Yup.string().min(10, "کارکترهای وارد شده کمتر از حد مجاز است"),
  });

  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  if (state.user_info === null && state.loading_data === false) {
    getProfileInfo(user).then((res) => {
      let user_info = res.data.data;
      props.user_info_loaded(user_info);
    });
  }

  function handleUpdatePassword() {
    const data = {
      oldPassword: oldPass,
      newPassword: newPass,
    };
    newPass === confirmPass
      ? updatePassword(user, data).then((res) => {
          if (res.data.status === 200) {
            props.sendMessage("پروفایل با موفقیت بروزرسانی شد", "success");
            setOldPass("");
            setNewPass("");
            setConfirmPass("");
          } else {
            props.sendMessage(" رمز فعلی اشتباه است ", "warning");
          }
        })
      : props.sendMessage(" مغایرت رمز ها ", "warning");
  }

  let d =
    state.user_info === null || state.user_info.dob == null
      ? new moment()
      : moment(state.user_info.dob, "YYYY-M-D");
  let birthday = {
    year: d.jYear(),
    month: d.jMonth(),
    day: d.jDate(),
  };
  return (
    <>
      {state.user_info !== null ? (
        <>
          <Snackbar
            open={state.snackOpen}
            autoHideDuration={8000}
            onClose={() => props.hideMessage()}
          >
            <Alert
              onClose={() => props.hideMessage()}
              severity={state.snackType}
            >
              {state.snackMessage}
            </Alert>
          </Snackbar>
          <Grid container spacing={3}>
            <Grid item sm={9}>
              <Paper elevation={3} style={{ padding: 20, marginBottom: 35 }}>
                <Formik
                  enableReinitialize={true}
                  validationSchema={CustomerEditSchema}
                  initialValues={state.user_info}
                  validateOnChange={(e) => {
                    document.getElementById("disbtn").style.display = "block";
                  }}
                  onSubmit={(values) => {
                    values.gender = parseFloat(values.gender);
                    values.gender_id = values.gender;
                    CustomerEditSchema.isValid(values).then((res) => {
                      if (res) {
                        updateProfileInfo(user, values).then((res) => {
                          if (res.status === 200) {
                            props.sendMessage(
                              "پروفایل با موفقیت بروزرسانی شد",
                              "success"
                            );
                            props.user_info_loaded(values);
                          } else {
                            props.sendMessage(" بروزرسانی ناموفق ", "warning");
                          }
                        });
                      } else {
                        return false;
                      }
                    });
                  }}
                >
                  {({ handleSubmit, errors, touched, values }) => {
                    return (
                      <>
                        <h3 data-testid="h3">مشخصات</h3>
                        <Divider style={{ marginBottom: 20 }} />
                        <Grid container>
                          <div className="col-xs-12 col-lg-4">
                            <Field
                              name="firstName"
                              component={Input}
                              placeholder="نام"
                              label="نام"
                              style={{
                                marginBottom: 20,
                                border: "1px solid gray",
                              }}
                            />
                            {touched.firstName ? (
                              <div>{touched.firstName}</div>
                            ) : null}
                          </div>
                          <div className="col-xs-12 col-lg-4">
                            <Field
                              name="lastName"
                              component={Input}
                              placeholder="نام خانوادگی"
                              label="نام خانوادگی"
                              style={{ marginBottom: 20 }}
                            />
                            {touched.lastName ? (
                              <div>{touched.lastName}</div>
                            ) : null}
                          </div>
                          <div className="col-xs-12 col-lg-4">
                            <Field
                              name="phone"
                              component={Input}
                              placeholder="شماره موبایل"
                              label="شماره موبایل"
                              style={{ marginBottom: 20 }}
                            />
                            {touched.phone ? <div>{touched.phone}</div> : null}
                          </div>
                          <div className="col-xs-12 col-lg-4">
                            <Field
                              id="nationalCode"
                              name="nationalCode"
                              component={Input}
                              placeholder="کد ملی"
                              label="کد ملی"
                              style={{ marginBottom: 20 }}
                            />
                            {touched.nationalCode ? (
                              <div>{touched.nationalCode}</div>
                            ) : null}
                          </div>
                          <div className="col-xs-12 col-lg-4">
                            <Field
                              name="email"
                              component={Input}
                              placeholder="ایمیل"
                              label="ایمیل"
                              style={{ marginBottom: 20 }}
                            />
                            {touched.email ? <div>{touched.email}</div> : null}
                          </div>

                          <div
                            className=" flex row col-sm-4 align-items-center justify-content-center mt-5"
                            id="edit-gender-section"
                          >
                            <h6 className="p-6">جنسیت :</h6>
                            <Field
                              name="gender"
                              render={({ field }) => (
                                <>
                                  <div
                                    className="radio-item mx-2"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      htmlFor="male"
                                      style={{ margin: "inherit" }}
                                    >
                                      مرد
                                    </label>
                                    <input
                                      {...field}
                                      id="male"
                                      value={parseFloat(1)}
                                      name="gender"
                                      type="radio"
                                    />
                                  </div>
                                  <div
                                    className="radio-item mx-2"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      htmlFor="female"
                                      style={{ margin: "inherit" }}
                                    >
                                      زن
                                    </label>
                                    <input
                                      {...field}
                                      id="female"
                                      value={parseFloat(0)}
                                      name="gender"
                                      type="radio"
                                    />
                                  </div>
                                </>
                              )}
                            />
                          </div>
                          <div className="col-sm-4 pt-4">
                            <h6>تاریخ تولد</h6>
                            <DatePicker
                              id="dob"
                              style={{
                                border: "1px solid #e4e6ef",
                                borderRadius: ".42rem",
                              }}
                              onChange={(value) => {
                                let birthday =
                                  value.year +
                                  "-" +
                                  value.month +
                                  "-" +
                                  value.day;
                                let user = state.user_info;
                                user.dob = moment(birthday, "jYYYY-jM-jD")
                                  .locale("en")
                                  .format("YYYY-M-D");
                                props.handle_variables("user_info", user);
                              }}
                              value={birthday}
                              inputPlaceholder="تاریخ تولد"
                              inputClassName={
                                "form-control form-control-solid h-auto py-5 px-6"
                              }
                              shouldHighlightWeekends
                              locale="fa"
                            />
                          </div>

                          <div
                            className="col-xs-12 col-lg-8"
                            style={{ marginTop: 10 }}
                          >
                            <Field
                              name="address"
                              component={Input}
                              placeholder="آدرس"
                              label="آدرس"
                              style={{ marginBottom: 20 }}
                            />
                            {touched.address ? (
                              <div>{touched.address}</div>
                            ) : null}
                          </div>
                          <div className="col-sm-4 p-6">
                            {values === state.user_info ? (
                              <button
                                disabled
                                id="disbtn"
                                className="btn btn-primary font-weight-bold py-3 px-6"
                              >
                                ویرایش اطلاعات
                              </button>
                            ) : (
                              <button
                                className="btn btn-primary font-weight-bold py-3 px-6"
                                id="disbtn"
                                onClick={() => {
                                  handleSubmit();
                                }}
                              >
                                ویرایش اطلاعات
                              </button>
                            )}
                          </div>
                        </Grid>
                      </>
                    );
                  }}
                </Formik>
              </Paper>
            </Grid>
            <Grid item sm={3}>
              <Paper elevation={3} style={{ padding: 20, marginBottom: 35 }}>
                <h3>ویرایش رمز عبور</h3>
                <Divider style={{ marginBottom: 20 }} />
                <Grid container spacing={3}>
                  <TextField
                    className="col-sm-10 ml-3"
                    dir="rtl"
                    type="password"
                    id="old_password"
                    label="رمز عبور قبلی"
                    defaultValue=""
                    margin="normal"
                    onChange={(e) => {
                      setOldPass(e.target.value);
                    }}
                    value={oldPass === null ? "" : oldPass}
                  />
                  <TextField
                    className="col-sm-10 ml-3"
                    dir="rtl"
                    id="new_password"
                    type="password"
                    label="رمز عبور جدید"
                    defaultValue=""
                    margin="normal"
                    onChange={(e) => {
                      setNewPass(e.target.value);
                    }}
                    value={newPass === null ? "" : newPass}
                  />
                  <TextField
                    className="col-sm-10 ml-3"
                    dir="rtl"
                    id="new_password_confirmation"
                    type="password"
                    label="تکرار رمز عبور جدید"
                    defaultValue=""
                    margin="normal"
                    onChange={(e) => {
                      setConfirmPass(e.target.value);
                    }}
                    value={confirmPass === null ? "" : confirmPass}
                  />
                  <Grid item sm={12}>
                    <button
                      className="btn btn-success font-weight-bold py-3 px-6"
                      onClick={() => handleUpdatePassword()}
                    >
                      تغییر رمز عبور
                    </button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </>
      ) : (
        <Grid
          item
          xs={12}
          className={"mt-4"}
          style={{
            height: "4rem",
            paddingBlock: "15px",
            backgroundColor: "white",
          }}
        >
          <b>null</b>
        </Grid>
      )}
    </>
  );
}

export default injectIntl(connect(null, account.actions)(UserInformationCard));
